// allTesterList -> Only Super Admin In dropdown
export const GET_TESTERS_REQUEST = 'GET_TESTERS_REQUEST';
export const GET_TESTERS_SUCCESS = 'GET_TESTERS_SUCCESS';
export const GET_TESTERS_FAILURE = 'GET_TESTERS_FAILURE';
// Existing Tester
export const GET_EXISTING_TESTERS_REQUEST = 'GET_EXISTING_TESTERS_REQUEST';
export const GET_EXISTING_TESTERS_SUCCESS = 'GET_EXISTING_TESTERS_SUCCESS';
export const GET_EXISTING_TESTERS_FAILURE = 'GET_EXISTING_TESTERS_FAILURE';
export const GET_EXISTING_TESTERS_UPDATE = 'GET_EXISTING_TESTERS_UPDATE';
export const REMOVE_EXISTING_TESTER = 'REMOVE_EXISTING_TESTER';
